import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersEmployeeSurveysAiSummaryMutateResponseType } from "~/domains";

type RequestDataType = {
  employeeSurveyId: string;
};

const request = ({ employeeSurveyId }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersEmployeeSurveysAiSummaryMutateResponseType>(
      `/api/managers/employee_surveys/${employeeSurveyId}/ai_summary`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersEmployeeSurveysAiSummaryCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersEmployeeSurveysAiSummaryMutateResponseType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
